
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('blog', { articles: 'getList' }),
      ...mapGetters('providers', { provider: 'get' })
    }
  };
